import Parsley from 'parsleyjs';

const PARSLEY_INCLUDE_SELECTOR = Parsley.options.inputs + ',[data-parsley-splitdate],[data-parsley-checkboxes-group],[data-parsley-splitdate-req]';

const EXEMPTION_YES = 'ExemptFromAllQualifying';
const EXEMPTION_FINAL = 'ExemptFinal';
const EXEMPTION_NO = 'NoExemption';

export default {
    PARSLEY_INCLUDE_SELECTOR,
    EXEMPTION_YES,
    EXEMPTION_FINAL,
    EXEMPTION_NO
};
